<template>
    <div class="modal fade" :id="id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ edit ? $t('events.planning.modification') : $t('events.planning.creation') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
  
            <div class="modal-body">
                <RequiredText></RequiredText>
                <div v-for="(formData, index) in formCreateData.program" :key="formData.id + '-' +index">
                  <div class="col-12 ">
                      <span class="form-label fs-6 text-black ">{{ $t('events.planning.name') }}</span>
                      <Input
                          :name="'event_title_'+id"
                          type="text"
                          :is-required="true"
                          v-model="formData.title"
                      />
                  </div>
                  <CKEditor
                      labelClass="form-label fs-6 text-black"
                      container-class="mb-5"
                      :label="$t('events.planning.description')"
                      :id="`event_description_`+id"
                      :required="false"
                      :key="'event_description_'+id+formData.id"
                      :content="formData.description"
                      @text="setDescription"
                  />

                  <InputDate
                      v-if="!withoutDate"
                      containerClass="mb-5"
                      :name="'planning_date'+id"
                      type="text"
                      :label="$t('events.planning.date')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-sm form-control-solid'"
                      :isRequired="true" 
                      size="lg"
                      :placeholder="$t('events.planning.date')"
                      v-model="formData.date"
                  />

                  <div class="row mb-5">
                      <div class="col-12 col-md-6 col-lg-6">
                          <span class="form-label fs-6 text-black required">{{ $t('events.planning.start_time') }}</span>
                          <Input
                              :name="'start_hour_'+id"
                              type="time"
                              v-model="formData.start_time"
                          />
                      </div>
                      <div class="col-12 col-md-6 col-lg-6">
                          <span class="form-label fs-6 text-black ">{{ $t('events.planning.end_time') }}</span>
                          <Input
                              :name="'end_hour_'+id"
                              type="time"
                              :is-required="false"
                              v-model="formData.end_time"
                          />
                      </div>
                  </div>

                  <div class="mt-5" v-for="(programEnum, key) in programEnums" :key="key">
                    <CheckboxInput
                      :label="programEnum[locale]"
                      :is-required="false"
                      v-model="formCreateData.atelier"
                      :bottom="false"
                    />
                  </div>

                  <div class="row mt-5" v-if="formData.type_program == 'ATELIER'">
                      <Select2
                          :parent-id="'#'+id"
                          :is-required="false"
                          container-class="col-12 col-md-6 col-lg-6"
                          :multiple="false"
                          :show-search="true"
                          :selectClass="'form-select form-control-lg form-select-solid'"
                          :name="'moderator_'+id"
                          :label="$t('events.planning.moderator')"
                          label-class="form-label fs-6 text-black"
                          :placeholder-text="$t('events.planning.moderator_placeholder')"
                          :IsInputGroup="true"
                          icon="bi bi-plus"
                          :clickAddon="moderatorCreate"
                          v-model="formData.moderator_id"
                      >
                          <option v-for="(moderator, index) in moderators" :key="index" :value="moderator.participator_id">
                            {{  moderator.firstname + ' ' + moderator.lastname }}
                          </option>
                      </Select2>

                      <Select2
                          :parent-id="'#'+id"
                          :is-required="false"
                          container-class="col-12 col-md-6 col-lg-6"
                          :multiple="false"
                          :show-search="true"
                          :selectClass="'form-select form-control-lg form-select-solid'"
                          :name="'presentator_'+id"
                          :label="$t('events.planning.presentator')"
                          label-class="form-label fs-6 text-black"
                          :placeholder-text="$t('events.planning.presentator_placeholder')"
                          :IsInputGroup="true"
                          icon="bi bi-plus"
                          :clickAddon="presentatorCreate"
                          v-model="formData.presentator_id"
                      >
                          <option v-for="(presentator, index) in presentators" :key="index" :value="presentator.participator_id">
                            {{  presentator.firstname + ' ' + presentator.lastname }}
                          </option>
                      </Select2>
                  </div>

                  <div class="form-group mt-5" v-if="formData.type_program == 'ATELIER'">
                    <div class="form-label d-flex justify-content-between align-items-center w-100 text-center">
                      <div class="radio-inline d-flex gap-4">
                        <label class="radio radio-primary d-flex align-items-center" v-for="(atelierType, key) in atelierTypesEnums" :key="key">
                          <input type="radio" v-model="formData.type_atelier" :value="atelierType.value" :name="'unzipRadion'+ atelierType.value"/>
                          <span class="form-label fs-6 text-black ms-3 mt-2">{{ atelierType[locale] }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <AddParticipatorModal id="create_participator_modal" :parent="id" :event-id="route.params.id" @created="loadData" />
</template>

<script setup>
    import {ref, defineProps, onMounted, computed, watch} from 'vue'
    import CKEditor from "@/components/CKEditor.vue";
    import Button from "@/components/Button";
    import Input from "@/components/Input.vue";
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText.vue"
    import InputDate from "@/components/InputDate2.vue";
    import Select2 from '@/components/Select2.vue';
    import {useRoute} from "vue-router";
    import AddParticipatorModal from "@/Modules/Events/components/modals/AddParticipatorModal.vue";
    import {useLocales} from "@/composables/locales";
    import CheckboxInput from '@/components/CheckboxInput.vue';

    const emits = defineEmits(["load"]);
    
    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        form: {
            type: Object,
            default: {
              event_id: '',
              id: '',
              atelier: false,
              program: [
                {
                  id: '',
                  title: '',
                  description: '',
                  date: '',
                  start_time: '',
                  end_time: '',
                  moderator_id: '',
                  presentator_id: '',
                  type_atelier: 'public',
                  type_program: ''
                }
              ]
            }
        },
        withoutDate: { type: Boolean, default: false },
        customDate: String,
        edit: {
            type: Boolean,
            default: false
        }
    })
  
    const store = useStore()
    const route = useRoute()
    const {locale} = useLocales()

    const isLoading  = ref(false)
    const formCreateData = ref(props.form)

    const moderators = computed(() => store.getters['planning/getModerators'])
    const presentators = computed(() => store.getters['planning/getPresentators'])
    const programEnums = computed(() => store.getters['planning/getProgramEnums'])
    const atelierTypesEnums = computed(() => store.getters['planning/getAtelierTypeEnum'])

    watch(() => props.form, (value) => {
        if(value) formCreateData.value = value
    }, { immediate: true, deep: true })


    watch(() => formCreateData.value?.atelier, (value) => {
      if(value) {
        formCreateData.value.program[0].type_program = 'ATELIER'
      }else{
        formCreateData.value.program[0].type_program = ''
        formCreateData.value.program[0].moderator_id = ''
        formCreateData.value.program[0].presentator_id = ''
      }
    })

    watch(() => route.query.tab, (value) => {
        if(value){
            loadData()
        }
    })
    
    function closeModal(){
      $('#'+props.id).modal('toggle')
    }

    function moderatorCreate(){
      $('#'+props.id).modal('toggle')
      $('#create_participator_modal').modal('toggle')
    }

    function presentatorCreate(){
      $('#'+props.id).modal('toggle')
      $('#create_participator_modal').modal('toggle')
    }
    
    function setDescription(text) {
      formCreateData.value.program[0].description = text
    }
    
    function submitForm() {
        isLoading.value = true;
        let action = props.edit ? 'planning/updatePlanning' : 'planning/createPlanning'
        let message = props.edit ? 'events.planning.updated_successfully' : 'events.planning.created_successfully'
        
        formCreateData.value.event_id = route.params.id
        let data = formCreateData.value
        data.program[0].date = props.withoutDate ? props.customDate.split('-').reverse().join('-') : formCreateData.value.program[0].date

        if(props.edit) {
          let formData = {
            title: formCreateData.value.program[0].title,
            description: formCreateData.value.program[0].description,
            date: formCreateData.value.program[0].date,
            start_time: formCreateData.value.program[0].start_time,
            end_time: formCreateData.value.program[0].end_time,
            id: formCreateData.value.id,
            event_id: formCreateData.value.event_id,
            moderator_id: formCreateData.value.program[0].moderator_id,
            presentator_id: formCreateData.value.program[0].presentator_id,
            type_atelier: formCreateData.value.program[0].type_atelier ?? 'public',
            type_program: formCreateData.value.program[0].type_program
          }
          data = formData
        }
        store
          .dispatch(action, data)
          .then(() => {
              isLoading.value = false;
              emits("load");
              closeModal();
              formCreateData.value = null
              formCreateData.value = {
                event_id: '',
                program: [
                  {
                    id: '',
                    title: '',
                    description: '',
                    date: '',
                    start_time: '',
                    end_time: '',
                    moderator_id: '',
                    presentator_id: '',
                    type_atelier: 'public',
                    type_program: ''
                  }
                ]
              }
              window.toastr["success"](i18n.global.t(message));
          })
          .catch((e) => {
              isLoading.value = false;
          });
    }

    function loadData() {
      store.dispatch('planning/loadModerators', route.params.id)
      store.dispatch('planning/loadPresentators', route.params.id)
      store.dispatch('planning/loadProgramEnum')
      store.dispatch('planning/loadAtelierTypeEnum')
    }

    onMounted(() => {
      loadData()
    })
</script>

<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>